import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  Renderer2,
} from '@angular/core';

@Component({
  selector: 'app-svg-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
})
export class ImageViewerComponent {
  /**
   * ターゲット要素
   */
  private target_element: any = null;

  /**
   * ターゲット要素の幅
   */
  private targetElementWidth: number = 0;

  /**
   * コンテンツの幅
   */
  public contentWidth: number = -1;

  /**
   * パネルの開閉状態
   */
  public isOpen = true;

  /**
   * 初期倍率
   */
  @Input() maxValue = 3;

  /**
   * 初期倍率
   */
  @Input() initValue = 2;

  /**
   *
   */
  @ViewChild('panel') panelRef!: ElementRef;

  /**
   *
   */
  @ViewChild('panelContent') panelContentRef!: ElementRef;

  /**
   * コンテンツ
   */
  @Input() content: any;

  /**
   *
   */
  private _content: any;

  /**
   * コンストラクタ
   * @param renderer renderer
   */
  constructor(private renderer: Renderer2) {}

  /**
   *
   */
  ngOnInit() {
    if (this.content) {
      this._content = this.content;
    }
  }

  /**
   *
   */
  ngAfterViewInit() {
    this.target_element = this.panelContentRef.nativeElement.appendChild(
      this._content
    );
    this.targetElementWidth = this.target_element.clientWidth;

    this.renderer.setStyle(
      this.target_element,
      'width',
      `${this.targetElementWidth * this.initValue}px`
    );
  }

  /**
   * スライド操作後に画像のサイズを変更する
   * @param event イベント
   */
  public onSlide(event: any): void {
    if (
      this.panelRef.nativeElement.clientWidth >
      this.targetElementWidth * event.value
    ) {
      this.renderer.setStyle(
        this.target_element,
        'width',
        `${this.targetElementWidth * event.value}px`
      );
    }
  }

  /**
   * パネルをクローズする
   */
  closePanel(): void {
    this.isOpen = false;
  }

  _close(): void {
    this.isOpen = false;
  }
}
